/*
 * File per la definizione dei Controller Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/controller
 */
define([
    'angular',
    'file-saver'
],

    function (angular, fileSaver) {

        var ristampaAnnullaAccreditamentoControllers = angular.module('ristampaAnnullaAccreditamentoControllers', []);

        ristampaAnnullaAccreditamentoControllers.controller('RistampaAnnullaAccreditamentoCtrl', ['$rootScope', '$scope', '$log', '$timeout', '$window', '$http', 'CONSTANTS', 'MessageService', 'ResourceService', RistampaAnnullaAccreditamentoCtrl]);

        function RistampaAnnullaAccreditamentoCtrl($rootScope, $scope, $log, $timeout, $window, $http, CONSTANTS, MessageService, ResourceService) {
            var vm = this;
            vm.invioClicked = false;

            // false=Ok|string=Ko
            vm.failCheck = false;

            vm.formRicerca = undefined;
            vm.input = {};
            vm.annullata = false;
            vm.datiInvio = undefined;
            vm.inputCaptcha = "";
            $rootScope.abilitaDelega = true;
            MessageService.clearMessages();

            //services
            vm.MessageService = MessageService;

            vm.actionDisabled = function () {
                if (vm.formRicerca.$invalid || vm.invioClicked || vm.failCheck ) {
                    return true;
                }
                return false;
            }

            vm.annullaOperazione = function () {
                vm.isClean = true;
                angular.element("#modal-conferma").modal('show');
            }

            vm.annulla = function () {
                angular.element("#modal-conferma").modal('hide');
                $timeout(function () {
                    vm.input = {};
                    vm.invioClicked = false;
                    vm.formRicerca.$setPristine();
                    MessageService.clearMessages();
                    $window.scroll(0, 0);
                }, 500);
            }

            vm.confermaOperazione = function () {
                vm.isClean = false;
                angular.element("#modal-conferma").modal('show');
            }
/*
$scope.$watch( angular.bind( this, function() {
 return [vm.input.cfEnte, vm.input.protocolloRichiesta];
} ), function() {
 if( vm.input.cfEnte && vm.input.protocolloRichiesta )
  ResourceService.checkAnnulla( vm.input ).then( function( response ) {
   vm.failCheck = ( response.data == 'OK' )? false : response.data;
  }, function( response ) {
   vm.failCheck = false;
  } );
 else
  vm.failCheck = false;
}, true );

*/

            vm.conferma = function () {
                angular.element("#modal-conferma").modal('hide');
                vm.invioClicked = true;
                var data = vm.input;
                $timeout(function () {
                    $window.scroll(0, 0);
                    ResourceService.annulla(data, vm.inputCaptcha).then(
                        function (response) {
                            vm.input = {};
                            vm.invioClicked = false;
                            vm.formRicerca.$setPristine();
                            vm.datiInvio = response.data;
                            MessageService.clearMessages();
                            vm.reloadCaptcha();
                        }, function (response) {
                            $log.error(response);
                            vm.invioClicked = false;
                            vm.reloadCaptcha();
                            response.data.messages[0].severity = 'ERROR';
                            MessageService.setMessages(response.data.messages);
                            MessageService.showMessages();

                        });
                }, 500);
            }

            vm.initFn = function (loadImg) {
                vm.reloadCaptcha = loadImg;
            }

            vm.scaricaPDF = function () {
                MessageService.clearMessages();
                const headerDict = {
                    "X-Content-Type-Options": "nosniff",
                    "X-XSS-Protection": "1; mode=block",
                    "X-Frame-Options": "deny",
                    "Strict-Transport-Security": "max-age=16070400; includeSubDomains",
                    "Cache-Control": "no-cache,no-store, must-revalidate, pre-check=0, post-check=0"
                }
                var method = 'POST';
                var data = vm.input;
                $http({
                    url: CONSTANTS.CONTEXT_REST_SERVICE + 'richiesta/ristampa?input-captcha=' + vm.inputCaptcha,
                    method: method,
                    responseType: 'arraybuffer',
                    headers: headerDict,
                    data: data
                }).then(function (result) {

                    var isJson = false;
                    try {
                        var headers = result.headers()
                        var contentType = headers['content-type'];
                        var fileNamePattern = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var fileName = fileNamePattern.exec(headers['content-disposition'])[1];
                        var blob = new Blob([result.data], { type: contentType });
                        var msgArray = [];
                        if (fileName.indexOf("_A.pdf") != -1) {
                            msgArray = [{ severity: 'SUCCESS', message: 'La stampa effettuata è relativa ad una richiesta di accreditamento annullata' }];
                            fileName = fileName.replace("_A", "");
                        } else
                        {
                            msgArray = [{ severity: 'SUCCESS', message: 'Stampa effettuata con successo' }];
                        }
                        fileSaver.saveAs(blob, fileName);                       
                        MessageService.setMessages(msgArray);
                        MessageService.showMessages();
                        vm.reloadCaptcha();
                    } catch (e) {
                        //nessuna risposta dal server
                        var msgArray = [{ severity: 'ERROR', message: 'Errore nella stampa della richiesta' }];
                        MessageService.setMessages(msgArray);
                        MessageService.showMessages();
                        vm.reloadCaptcha();
                    }

                }, function error(data) {
                    $log.error(data);
                    var msgArray = [{ severity: 'ERROR', message: data.headers('msg') }];
                    MessageService.setMessages(msgArray);
                    MessageService.showMessages();
                    vm.reloadCaptcha();
                });
            }
        };

        return ristampaAnnullaAccreditamentoControllers;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/controllers/ristampa-annulla-accreditamento-controllers.js
// module id = 35
// module chunks = 1